import { DatePicker } from "antd";
import moment from "moment";
import React from "react";

const AllDatePicker = ({ name, onChange, error, required, value }) => {
  return (
    <>
      <label className="font-weight-bolder font-size-sm">
        {name} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <DatePicker
        picker="year"
        className={error ? "invalid" : ""}
        style={{
          width: "100%",
          height: "100%",
        }}
        value={value ? moment(value, "YYYY") : ""}
        onChange={onChange}
      />
      <small className="text-danger">{error}</small>
    </>
  );
};

export default AllDatePicker;
